import { Loader } from '@googlemaps/js-api-loader'

// Define a TypeScript interface for the Google Maps instance
export interface GoogleMapsInstance {
  maps: google.maps.MapsLibrary
  marker: google.maps.MarkerLibrary
}

// This will be our composable function
export default function useGoogleMaps() {
  const runtimeConfig = useRuntimeConfig()
  const instance = ref<GoogleMapsInstance | null>(null)

  // Initialize the Google Maps API Loader
  const initGoogleMaps = async () => {
    if (instance.value !== null) {
      return instance.value
    }

    const loader = new Loader({
      apiKey: runtimeConfig.public.GOOGLE_MAPS_API_KEY,
      version: 'weekly',
    })

    const [maps, marker] = await Promise.all([
      loader.importLibrary('maps'),
      loader.importLibrary('marker'),
    ])

    instance.value = {
      maps,
      marker,
    }

    return instance.value
  }

  // Return the reactive properties and methods to be used in components
  return {
    initGoogleMaps,
    instance,
  }
}
